<template>
  <div class="threshold-setting-container">
    <!-- 头部搜索区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- 左侧：三个下拉框 -->
        <div class="left-dropdowns">
          <el-form-item label="所属项目：">
            <el-select
              v-model="searchForm.projectId"
              placeholder="请选择项目"
              v-el-select-loadmore="loadMore"
              clearable
              style="width: 200px"
              @change="onProjectChange"
            >
              <el-option
                v-for="item in project.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="阈值名称：">
            <el-select
              v-model="searchForm.thresholdId"
              placeholder="请选择阈值名称"
              clearable
              style="width: 200px"
              :disabled="!searchForm.projectId"
              @change="onThresholdChange"
            >
              <el-option
                v-for="item in thresholdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="在线设备SN号：">
            <el-select
              v-model="searchForm.deviceSn"
              placeholder="请选择设备"
              clearable
              style="width: 200px"
              :disabled="!searchForm.projectId"
              @change="onDeviceChange"
            >
              <el-option
                v-for="item in deviceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>

        <!-- 右侧：三个按钮 -->
        <div class="right-buttons">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-setting"
              @click="handleThresholdConfig"
              :loading="configLoading"
            >
              阈值配置
            </el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              type="success"
              icon="el-icon-download"
              :disabled="!canRead"
              @click="handleThresholdRead"
            >
              阈值读取
            </el-button>
          </el-form-item>

          <!-- <el-form-item>
            <el-button
              type="warning"
              icon="el-icon-upload2"
              :disabled="!canExport"
              @click="handleThresholdExport"
            >
              阈值导出
            </el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </div>

    <!-- 阈值展示区域 -->
    <div v-if="showThresholdData" class="threshold-data-area">
      <div class="threshold-header">
        <h3>阈值配置详情</h3>
        <div class="header-info">
          <span>项目：{{ currentProjectName }}</span>
          <!-- <span>阈值名称：{{ currentThresholdName }}</span> -->
          <span>设备：{{ currentDeviceSn }}</span>
          <!-- <span>读取时间：{{ readTime }}</span> -->
        </div>
      </div>

      <el-table
        :data="thresholdData"
        border
        stripe
        style="width: 100%; margin-top: 20px"
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" width="60" align="center" />
        <!-- <el-table-column label="排序" prop="order" width="80" align="center" /> -->
        <el-table-column label="阈值Key" prop="key" min-width="150" />
        <el-table-column label="阈值Value" prop="value" min-width="150" />
        <el-table-column label="阈值描述" prop="description" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.description || "-" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getThresholdDetail,
  getThresholdByProjectId,
  getOnlineDevicesByProjectId,
  setThreshold,
  getThresholdRecord,
  readDeviceThreshold
} from "@/store/threshold";
import { cat } from "shelljs";

export default {
  name: "ThresholdSetting",
  data() {
    return {
      // 搜索表单
      searchForm: {
        projectId: "",
        thresholdId: "",
        deviceSn: ""
      },
      configLoading: false,
      // 下拉框选项
      thresholdOptions: [],
      deviceOptions: [],

      // 当前选择的信息
      currentProjectName: "",
      currentThresholdName: "",
      currentDeviceSn: "",
      readTime: "",

      // 阈值数据
      thresholdData: [],
      showThresholdData: false,
      loading: false,
      project: {
        total: 0,
        list: [],
        pageNo: 1
      }
    };
  },
  computed: {
    // 是否可以读取（选择了项目和阈值名称）
    canRead() {
      return this.searchForm.projectId && this.searchForm.deviceSn;
    },
    // 是否可以导出（有数据展示）
    canExport() {
      return this.thresholdData && this.thresholdData.length > 0;
    }
  },
  created() {
    this.getProjects(1);
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          if (Math.abs(scrollHeight - scrollTop - clientHeight) < 1) {
            binding.value();
          }
        });
      }
    }
  },
  methods: {
    // 加载项目列表
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));
          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },

    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
      }
    },

    // 项目变更
    async onProjectChange(projectId) {
      if (projectId) {
        // 更新当前项目名称
        const project = this.project.list.find(p => p.value === projectId);
        this.currentProjectName = project ? project.label : "";

        // 加载该项目的阈值列表
        await this.loadThresholdList(projectId);

        // 加载该项目的设备列表
        await this.loadDeviceList(projectId);

        // 清空相关选择
        this.searchForm.thresholdId = "";
        this.searchForm.deviceSn = "";
      } else {
        // 清空所有
        this.searchForm.thresholdId = "";
        this.searchForm.deviceSn = "";
        this.thresholdOptions = [];
        this.deviceOptions = [];
        this.currentProjectName = "";
      }
      this.resetThresholdData();
    },

    async onDeviceChange(deviceSn) {
      console.log("onDeviceChange", deviceSn);
      if (deviceSn) {
        this.currentDeviceSn = deviceSn;
        // 读取设备阈值
      }
    },
    // 加载阈值列表
    async loadThresholdList(projectId) {
      try {
        // 这里需要根据您的API调整
        const response = await getThresholdByProjectId(projectId);
        this.thresholdOptions = response.map(item => ({
          value: item.thresholdId,
          label: item.name
        }));
      } catch (error) {
        console.error("加载阈值列表失败:", error);
      }
    },

    // 加载设备列表
    async loadDeviceList(projectId) {
      try {
        // 这里需要根据您的API调整
        const response = await getOnlineDevicesByProjectId(projectId);
        this.deviceOptions = response.map(item => ({
          value: item,
          label: item
        }));
      } catch (error) {
        console.error("加载设备列表失败:", error);
      }
    },

    // 阈值名称变更
    onThresholdChange(thresholdId) {
      if (thresholdId) {
        const threshold = this.thresholdOptions.find(
          t => t.value === thresholdId
        );
        this.currentThresholdName = threshold ? threshold.label : "";
      } else {
        this.currentThresholdName = "";
      }
      this.resetThresholdData();
    },

    // 阈值配置按钮
    async handleThresholdConfig() {
      if (!this.searchForm.thresholdId) {
        this.$message.warning("请先选择阈值名称");
        return;
      }
      if (!this.searchForm.deviceSn) {
        this.$message.warning("请先选择设备");
        return;
      }

      // 设置按钮loading状态
      this.configLoading = true;

      try {
        const response = await setThreshold(this.searchForm);

        if (response.msgId) {
          // 显示等待提示
          this.$message.success("配置发送成功，等待设备响应...");

          // 延迟5秒后查询
          await new Promise(resolve => setTimeout(resolve, 3000));

          const resp = await getThresholdRecord({
            msgId: response.msgId,
            type: "config"
          });

          // 处理返回结果
          this.handleResponse(resp);
        }
      } catch (error) {
        console.error("配置失败:", error);
        this.$message.error("配置失败: " + (error.message || "未知错误"));
      } finally {
        // 关闭按钮loading
        this.configLoading = false;
      }
    },

    handleResponse(resp) {
      console.log("设备响应:", resp);
      if (resp == null || resp.msg == null) {
        this.$message.error("阈值配置失败");
        return;
      }

      // 根据状态显示不同信息
      switch (resp.msg.errorCode) {
        // case 0:
        //   this.$message.info("配置已发送，等待设备接收");
        //   break;
        // case 1:
        //   this.$message.success("设备已接收配置");
        //   break;
        case 200:
          this.$message.success("阈值配置成功");
          // 可以在这里刷新数据或进行其他操作
          break;
        case 201:
          this.$message.error("阈值配置失败: " + (resp.msg.errorMsg || ""));
          break;
        default:
          this.$message.warning("未知的设备状态");
      }
    },

    // 阈值读取按钮
    async handleThresholdRead() {
      if (!this.searchForm.deviceSn) {
        this.$message.warning("请先选择设备");
        return;
      }

      this.loading = true;
      try {
        const response = await readDeviceThreshold(this.searchForm.deviceSn);
        if (response.msgId) {
          this.$message.success("阈值读取发送成功，等待设备响应...");
          // 延迟5秒后查询
          await new Promise(resolve => setTimeout(resolve, 3000));

          const resp = await getThresholdRecord({
            msgId: response.msgId,
            type: "read"
          });
          this.thresholdData = [];
          Object.keys(resp.threshold).forEach(key => {
            const value = resp.threshold[key];
            const item = {
              key: key,
              value: value.toString(),
              description: ""
            };
            this.thresholdData.push(item);
          });
          this.showThresholdData = true;
          console.log("阈值读取结果:", this.thresholdData);
        }
      } catch (error) {
        console.error("阈值读取失败:", error);
        this.$message.error("阈值读取失败");
      } finally {
        this.loading = false;
      }
    },

    // 阈值导出按钮
    handleThresholdExport() {
      if (this.thresholdData.length === 0) {
        this.$message.warning("没有数据可导出");
        return;
      }

      try {
        // 准备导出数据
        const exportData = {
          project: this.currentProjectName,
          thresholdName: this.currentThresholdName,
          deviceSn: this.currentDeviceSn,
          readTime: this.readTime,
          configs: this.thresholdData
        };

        // 转换为JSON字符串
        const dataStr = JSON.stringify(exportData, null, 2);
        const dataBlob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(dataBlob);
        const link = document.createElement("a");

        link.href = url;
        const filename = `${
          this.currentThresholdName
        }_${new Date().getTime()}.json`;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败");
      }
    },

    // 重置阈值数据
    resetThresholdData() {
      this.thresholdData = [];
      this.showThresholdData = false;
      this.currentDeviceSn = "";
      this.readTime = "";
    }
  }
};
</script>

<style lang="less" scoped>
.threshold-setting-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-area {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;

  .demo-form-inline {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-dropdowns {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;
    }

    .right-buttons {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}

.threshold-data-area {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;

  .threshold-header {
    margin-bottom: 15px;

    h3 {
      margin: 0 0 10px 0;
      color: #303133;
      font-size: 16px;
      font-weight: 600;
    }

    .header-info {
      display: flex;
      gap: 30px;
      color: #606266;
      font-size: 14px;

      span {
        display: inline-block;
      }
    }
  }
}

.threshold-row {
  background-color: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px 0;

  &:hover {
    background-color: #f0f9ff;
    border-color: #c6e2ff;
  }
}

.action-buttons {
  display: flex;
  gap: 5px;
}

// 响应式适配
@media (max-width: 1200px) {
  .search-area .demo-form-inline {
    flex-direction: column;
    align-items: stretch;

    .left-dropdowns {
      margin-bottom: 15px;
      justify-content: center;
    }

    .right-buttons {
      justify-content: center;
    }
  }
}

@media (max-width: 768px) {
  .left-dropdowns {
    flex-direction: column;
    align-items: stretch !important;

    .el-form-item {
      width: 100%;

      .el-select {
        width: 100% !important;
      }
    }
  }

  .right-buttons {
    flex-wrap: wrap;
    justify-content: center !important;
  }

  .header-info {
    flex-direction: column;
    gap: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/thresholdManagement/thresholdSetting.vue